import { get } from 'lodash';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  workstationPhoneId: get(state, 'query.all.workstationPhoneId'),
});

export default Component => connect(mapStateToProps)(Component);
